export function getUrlParams(search) {
  let hashes = search.slice(search.indexOf('?') + 1).split('&')
  return hashes.reduce((params, hash) => {
    let [key, val] = hash.split('=')
    return Object.assign(params, {[key]: decodeURIComponent(val)})
  }, {})
}

export function pushUrlParams(history, params) {
  const query = Object.keys(params).map(key => `${key}=${encodeURIComponent(params[key])}`).join('&')
  const pathQuery = `${history.location.pathname}?${query}`
  history.push(pathQuery)
}


// WEBPACK FOOTER //
// ./src/services/service-url-search-params.js